/*
 *
 * ChargebackDownloadPopup
 *
 * @version 1.0.0
 * @author Lucio Chiummo
 * @since 15-Sep-2025
 */

import React, { useState } from 'react'
import PropTypes from 'prop-types'
import formattedMessage from './languageModule'
import Toggle from 'Hoc/ToggleComponent'
import './ChargebackDownloadPopup.scss'
import MerchantModal from '@nexidigital/merchantmodal'
import { DocumentCVS, DocumentXLS } from '@nexidigital/iconlibrary'
import MerchantToastMessage from '@nexidigital/merchanttoastmessage'

const ChargebackDownloadPopup = (props) => {
  const [selectedDownloadType, setType] = useState(null)

  const downloadFiles = (fileType) => {
    setType(fileType)
    switch (props.data.component) {
      case 'refunds':
        return props.actions.doGetRefundsDownload({ paymentId: props.data.paymentId, fileFormat: fileType })
      case 'chargeback':
        return props.actions.doGetCompensationDownload({ paymentId: props.data.paymentId, fileFormat: fileType })
      default:
    }
  }
  return (
    <Toggle>
      <MerchantModal
        ariaModalDescription=''
        ariaModalTitle=''
        title={formattedMessage.title(props.data.component)}
        description={formattedMessage.date(props.data.date)}
        onClose={() => props.actions.doHidePopup()}
        primaryButtonLabel={formattedMessage.downloadButton('XLS')}
        primaryIcon={<DocumentXLS size='20' type='line' />}
        primaryButtonTertiary
        primaryButtonLoading={props.isLoading && selectedDownloadType === 'EXCEL'}
        secondaryButtonLabel={formattedMessage.downloadButton('CSV')}
        secondaryIcon={<DocumentCVS size='20' type='line' />}
        secondaryButtonTertiary
        secondaryButtonLoading={props.isLoading && selectedDownloadType === 'CSV'}
        primaryAction={() => downloadFiles('EXCEL')}
        secondaryAction={() => downloadFiles('CSV')}
      >
        <MerchantToastMessage severity='info' showOnPage hideClose label={formattedMessage.description} />
      </MerchantModal>
    </Toggle>
  )
}

ChargebackDownloadPopup.propTypes = {
  actions: PropTypes.object,
  data: PropTypes.object,
  isLoading: PropTypes.bool
}

ChargebackDownloadPopup.defaultProps = {
  actions: {},
  data: {},
  isLoading: false
}

export default ChargebackDownloadPopup
